import { commonjsGlobal as p } from "./index61.js";
import { __exports as r } from "./index150.js";
import "./index148.js";
import { __exports as I } from "./index151.js";
var s = p && p.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, o) {
      i.__proto__ = o;
    } || function(i, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (i[a] = o[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function i() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(), c = p && p.__assign || function() {
  return c = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, c.apply(this, arguments);
};
Object.defineProperty(r, "__esModule", { value: !0 });
r.cloneNode = r.hasChildren = r.isDocument = r.isDirective = r.isComment = r.isText = r.isCDATA = r.isTag = r.Element = r.Document = r.CDATA = r.NodeWithChildren = r.ProcessingInstruction = r.Comment = r.Text = r.DataNode = r.Node = void 0;
var u = I, b = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), g(this, t);
    }, e;
  }()
);
r.Node = b;
var m = (
  /** @class */
  function(e) {
    s(t, e);
    function t(n) {
      var i = e.call(this) || this;
      return i.data = n, i;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(b)
);
r.DataNode = m;
var v = (
  /** @class */
  function(e) {
    s(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = u.ElementType.Text, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m)
);
r.Text = v;
var x = (
  /** @class */
  function(e) {
    s(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = u.ElementType.Comment, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m)
);
r.Comment = x;
var T = (
  /** @class */
  function(e) {
    s(t, e);
    function t(n, i) {
      var o = e.call(this, i) || this;
      return o.name = n, o.type = u.ElementType.Directive, o;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m)
);
r.ProcessingInstruction = T;
var h = (
  /** @class */
  function(e) {
    s(t, e);
    function t(n) {
      var i = e.call(this) || this;
      return i.children = n, i;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(b)
);
r.NodeWithChildren = h;
var C = (
  /** @class */
  function(e) {
    s(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = u.ElementType.CDATA, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(h)
);
r.CDATA = C;
var P = (
  /** @class */
  function(e) {
    s(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = u.ElementType.Root, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(h)
);
r.Document = P;
var O = (
  /** @class */
  function(e) {
    s(t, e);
    function t(n, i, o, a) {
      o === void 0 && (o = []), a === void 0 && (a = n === "script" ? u.ElementType.Script : n === "style" ? u.ElementType.Style : u.ElementType.Tag);
      var l = e.call(this, o) || this;
      return l.name = n, l.attribs = i, l.type = a, l;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(i) {
          var o, a;
          return {
            name: i,
            value: n.attribs[i],
            namespace: (o = n["x-attribsNamespace"]) === null || o === void 0 ? void 0 : o[i],
            prefix: (a = n["x-attribsPrefix"]) === null || a === void 0 ? void 0 : a[i]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(h)
);
r.Element = O;
function D(e) {
  return (0, u.isTag)(e);
}
r.isTag = D;
function j(e) {
  return e.type === u.ElementType.CDATA;
}
r.isCDATA = j;
function N(e) {
  return e.type === u.ElementType.Text;
}
r.isText = N;
function E(e) {
  return e.type === u.ElementType.Comment;
}
r.isComment = E;
function A(e) {
  return e.type === u.ElementType.Directive;
}
r.isDirective = A;
function _(e) {
  return e.type === u.ElementType.Root;
}
r.isDocument = _;
function S(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
r.hasChildren = S;
function g(e, t) {
  t === void 0 && (t = !1);
  var n;
  if (N(e))
    n = new v(e.data);
  else if (E(e))
    n = new x(e.data);
  else if (D(e)) {
    var i = t ? d(e.children) : [], o = new O(e.name, c({}, e.attribs), i);
    i.forEach(function(w) {
      return w.parent = o;
    }), e.namespace != null && (o.namespace = e.namespace), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = c({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = c({}, e["x-attribsPrefix"])), n = o;
  } else if (j(e)) {
    var i = t ? d(e.children) : [], a = new C(i);
    i.forEach(function(y) {
      return y.parent = a;
    }), n = a;
  } else if (_(e)) {
    var i = t ? d(e.children) : [], l = new P(i);
    i.forEach(function(y) {
      return y.parent = l;
    }), e["x-mode"] && (l["x-mode"] = e["x-mode"]), n = l;
  } else if (A(e)) {
    var f = new T(e.name, e.data);
    e["x-name"] != null && (f["x-name"] = e["x-name"], f["x-publicId"] = e["x-publicId"], f["x-systemId"] = e["x-systemId"]), n = f;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return n.startIndex = e.startIndex, n.endIndex = e.endIndex, e.sourceCodeLocation != null && (n.sourceCodeLocation = e.sourceCodeLocation), n;
}
r.cloneNode = g;
function d(e) {
  for (var t = e.map(function(i) {
    return g(i, !0);
  }), n = 1; n < t.length; n++)
    t[n].prev = t[n - 1], t[n - 1].next = t[n];
  return t;
}
export {
  r as default
};
